<div class="canvas-container-component-div" [ngClass]="{'none-value': noneValue}">
  <h4 *ngIf="title">{{title}}</h4>
  <!-- <canvas #chart_element></canvas> -->
  <div class="chart-container" #chart_element></div>
  <div class="none-value-container">
    <ng-content></ng-content>
  </div>
</div>
